import React from 'react';
import { ActivityIndicator, Image, StyleSheet, View } from 'react-native';

import { colors, spacing } from '../theme/tokens';

const splashLogo = require('../../assets/branding/splash-lockup.png');

/** Full-screen splash — complete lockup, uncropped. */
export function BootSplash() {
  return (
    <View style={styles.wrap} accessibilityRole="progressbar" accessibilityLabel="Loading MoneyLens">
      <Image source={splashLogo} resizeMode="contain" style={styles.logo} />
      <ActivityIndicator color={colors.accent} style={styles.spinner} />
    </View>
  );
}

const styles = StyleSheet.create({
  wrap: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#000000',
  },
  logo: {
    width: 280,
    height: 280,
  },
  spinner: {
    marginTop: spacing.lg,
  },
});
